import React from 'react';
import TimerForm from './TimerForm';
import { modifyTimer } from '../../api';
import { connect } from 'react-redux';
import { onModificationSuccess } from './util';

const onSubmit = (values, timer) => Object.assign({}, timer, values);

const mapStateToProps = (state) => (
  {
    name: 'modifyTimer',
    id: state.app.timers.detail.id,
    selectedObject: state.app.timers.detail,
    request: modifyTimer,
    initialValues: state.app.timers.detail,
    onSubmit,
    onSuccess: onModificationSuccess,
  }
);

const TimerDetail = connect(
  mapStateToProps
)(TimerForm);

export default TimerDetail;

export class Timer extends React.Component {

  render() {
    return (
      <TimerDetail
        appBar={{
          title: 'TIMER',
          navigateBack: true,
        }}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Timer/Timer.js
 **/